import React from 'react'
import styled, { keyframes } from 'styled-components'
import INFTButton from './INFTButton'

const pendingAnimation = keyframes`
  0% {
    background: #3D5A80;
  }

  20% {
    background: #FF6871;
  }

  40% {
    background: #27AE60;
  }

  60% {
    background: #EE6C4D;
  }

  80% {
    background: #98C1D9;
  }

  100% {
    background: #3D5A80;
  }
`

const NFTButtonItem = styled.div`
  width: 100%;
  text-align: center;
  background: ${({ theme }) => theme.bg6};
  color: #fff;
  padding: 0.5rem;
  margin-top: 0.5rem;
  font-weight: bold;
  cursor: pointer;
  user-select: none;

  :hover {
    background: ${({ theme }) => theme.bg7};
  }

  &.disabled {
    background: ${({ theme }) => theme.bg5};
    cursor: not-allowed;
    :hover {
      background: ${({ theme }) => theme.bg5};
    }
  }

  &.pending {
    animation: 4s ${pendingAnimation} linear infinite;
    transition: background ease 2s;
  }
`

export default function NFTButton({ text, onClick, disable, className }: INFTButton) {
  function onClickTrigger() {
    if (!disable && onClick) {
      onClick()
    }
  }

  return (
    <NFTButtonItem
      className={`${className ? className : ''} nft-button ${disable ? 'disabled' : ''}`}
      onClick={onClickTrigger}
    >
      {text}
    </NFTButtonItem>
  )
}
